import { Value } from "@stringtale/react"
import styled from "@emotion/styled"
import { useRouter } from "app/core/hooks/useRouter"
import {
  DARK_BLUE_COLOR,
  LIGHT_GREEN_COLOR,
  LIGHT_GREY_COLOR,
  ORANGE_COLOR,
  PX18,
  PX24,
} from "theme/consts"
import Button from "ui/Button"

const Body = styled.div`
  background-color: ${LIGHT_GREEN_COLOR};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const ErrorContainer = styled.div`
  padding: 40px;
  border: 1px solid ${LIGHT_GREY_COLOR};
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 25px;
  text-align: center;
  max-width: 50%;
  align-items: center;
  box-sizing: border-box;
  margin: 60px;
  @media (max-width: 1248px) {
    max-width: 80%;
    padding: 20px;
  }
`

const ErrorTitle = styled.h2`
  font-size: ${PX24};
  font-weight: 900;
  color: ${DARK_BLUE_COLOR};
`

const ErrorMessage = styled.span`
  font-size: ${PX18};
  color: ${DARK_BLUE_COLOR};
  margin-bottom: 10px;
`

const ErrorButton = styled(Button)`
  background-color: ${ORANGE_COLOR};
  border-radius: 50px;
  color: white;
  height: 50px;
  width: 200px;
`

export const NotAuthorized = function () {
  const router = useRouter()

  return (
    <>
      <Body>
        <ErrorContainer>
          <ErrorTitle>
            <Value name="apps.web.src.errors.notauthorized.title">
              Foutcode 403
            </Value>
          </ErrorTitle>
          <ErrorMessage>
            <Value name="apps.web.src.errors.notauthorized.message">
              Je hebt helaas geen rechten om deze pagina te bekijken.
            </Value>
          </ErrorMessage>
          <ErrorButton
            onClick={async () => {
              router.push("/")
            }}
          >
            <Value name="apps.web.src.errors.notauthorized.terug_naar_home">
              Terug naar home
            </Value>
          </ErrorButton>
        </ErrorContainer>
      </Body>
    </>
  )
}
